/* Svensk katalog for locale-no.js (del 3 av 10).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'set.import.packages.statusUploaded': 'Uppladdad',
  'set.import.packages.uploadedAt': 'Uppladdad {date}',
  'set.import.packages.readAt': 'Senast avläst {date}',
  'set.import.packages.importedAt': 'Importerad till bokföringen {date}',
  'set.import.packages.notAvailable': 'Okänd tidpunkt',
  'set.import.packages.unknownSize': 'Okänd storlek',
  'set.import.packages.deleteConfirm': 'Ta bort {name}? ZIP-filen och tillfälliga analysdata tas bort permanent. Inga bokföringsdata har importerats från det här paketet.',
  'set.import.packages.deletePreviousConfirm': 'Ta bort det tidigare importpaketet {name}? Importerade bokföringsdata finns kvar. Dokument som bara finns i den här äldre ZIP-filen kan inte öppnas efter borttagningen.',
  'set.import.packages.deleteDialogTitle': 'Ta bort importpaket?',
  'set.import.packages.deleteDialogBody': 'Du håller på att ta bort {name}. ZIP-filen och tillhörande analysdata tas bort permanent från backend.',
  'set.import.packages.deletePreviousBody': 'Du håller på att ta bort det tidigare importpaketet {name}. Bokföringsdata finns kvar, men dokument som bara finns i den här ZIP-filen kan inte öppnas efteråt.',
  'set.import.packages.deleteIrreversible': 'Den här åtgärden kan inte ångras.',
  'set.import.packages.replaceTitle': 'Ersätta befintligt importpaket?',
  'set.import.packages.replaceBody': 'Du har redan importpaketet {name}. När det nya paketet har analyserats och godkänts blir det nya aktivt och alla äldre ZIP-paket tas bort från backend.',
  'set.import.packages.replaceSafety': 'Det befintliga paketet behålls medan det nya laddas upp och analyseras. Om analysen misslyckas eller avbryts förblir det nuvarande aktiva paketet orört.',
  'set.import.packages.replacePermanent': 'Efter godkännande kan borttagningen av det gamla paketet inte ångras.',
  'set.import.packages.chooseReplacement': 'Välj ny ZIP',
  'set.import.packages.deleteProtected': 'Paketet används i bokföringen och kan inte tas bort här.',
  'set.import.packages.protectedHelp': 'Det här är den aktiva källan för importerade verifikationsdokument och kan därför inte tas bort.',
  'set.import.packages.duplicateHelp': 'Filinnehållet är identiskt med det aktiva importpaketet och kan tas bort.',
  'set.import.packages.deleting': 'Tar bort...',
  'set.import.packages.delete': 'Ta bort',
  'set.import.packages.deleted': 'Importpaketet har tagits bort.',
  'set.import.packages.deleteFailed': 'Kunde inte ta bort importpaketet.',
  'set.import.packages.deleteMissing': 'Lagringssökväg för importpaketet saknas.',
  'set.import.packages.download': 'Ladda ner ZIP',
  'set.import.packages.downloading': 'Förbereder...',
  'set.import.packages.downloadMissing': 'Lagringssökväg för importpaketet saknas.',
  'set.import.packages.downloadStarted': 'Nedladdningen av original-ZIP har startat.',
  'set.import.packages.downloadFailed': 'Kunde inte ladda ner importpaketet.',
  'set.import.years.title': 'Välj dataår',
  'set.import.years.help': 'Bara data och siffror för valda år importeras. Register och dokumentarkivet hanteras separat.',
  'set.import.years.recommended': 'Rekommenderad period',
  'set.import.years.previousOnly': 'Bara tidigare år',
  'set.import.years.all': 'Alla år',
  'set.import.years.current': 'innevarande år',
  'set.import.years.retentionWarning': 'Du har valt bort {years}, som kan ligga inom den normala arkiveringstiden. Se till att materialet sparas någon annanstans.',
  'set.import.years.documentsPreserved': 'Original-ZIP och dokumentarkiv behålls kompletta oavsett årsval.',
  'set.import.years.importedTitle': 'Importerade dataår',
  'set.import.years.importedHelp': 'Du kan ta bort importerade siffror för ett år utan att radera ZIP, dokumentarkiv eller manuellt skapade poster.',
  'set.import.years.removeYear': 'Ta bort importerade data för {year}',
  'set.import.years.removeTitle': 'Ta bort importerade data för {year}?',
  'set.import.years.removeBody': 'Importerad ingående balans, rapporthistorik, årsspecifika öppna poster och importerade kontrollstatusar för {year} tas bort.',
  'set.import.years.removePreserves': 'Manuella fakturor, köp, verifikationer, register, original-ZIP och dokumentarkiv behålls.',
  'set.import.years.removeConfirm': 'Ta bort data',
  'set.import.years.removing': 'Tar bort...',
  'set.import.years.removed': 'Tog bort {count} importerade datapunkter för {year}.',
  'set.import.years.removeFailed': 'Kunde inte ta bort importerade årsdata.',
  'set.import.years.invalid': 'Välj ett giltigt importår.',
  'set.import.years.selectedLedgerRows': 'historikrader under valda år',
  'set.showAll': 'Visa alla',
  'set.count.accounts': 'saldokonton',
  'set.count.customers': 'kunder',
  'set.count.products': 'produkter',
  'set.count.openSalesInvoices': 'öppna kundfakturor',
  'set.count.openPurchaseInvoices': 'öppna leverantörsfakturor',
  'set.count.suppliers': 'leverantörer',
  'set.count.openingBalances': 'ingående balanser',
  'set.import.after': 'Efter import',
  'set.noMatches': 'Inga träffar.',
  'set.preview': 'Förhandsgranskning',
  'set.previewHeading': 'Så här ser dokumentet ut',
  'set.preview.sender': 'Avsändare:',
  'set.preview.invoiceNo': 'Fakturanr:',
  'set.preview.invoiceDate': 'Fakturadatum:',
  'set.preview.dueDate': 'Förfallodatum:',
  'set.preview.accountNo': 'Kontonr:',
  'set.preview.toPay': 'Att betala:',
  'set.preview.docType': 'FAKTURA',
  'set.preview.noCustomer': 'Ingen kund vald ännu',
  'set.preview.net': 'Netto',
  'set.preview.vat': 'Moms',
  'set.preview.toPayShort': 'Att betala',
  'set.menu.title': 'Sidomeny',
  'set.menu.help': 'Välj vilka sidor som visas i menyn till vänster. Kärnsidor är alltid synliga.',
  'set.menu.showAll': 'Visa alla sidor',
  'set.xlsx': 'XLSX',
  'set.csv': 'CSV',
  'set.import': 'Importera',
  'set.data.accountingTitle': 'Import / Export av bokföring',
  'set.data.accountingSub': 'Importera från ett annat bokföringssystem med en eller flera ZIP-, SAF-T-, CSV- eller Excel-filer, och exportera säkerhetskopia och bokföringsöversikt.',
  'set.export': 'Exportera',
  'set.data.invoiceCsv': 'Faktura CSV',
  'set.data.invoiceTemplate': 'Mall för fakturaimport',
  'set.data.bookkeepingCsv': 'Bokföring CSV',
  'set.data.reusePackage': 'Använder den uppladdade exportfilen igen, utan ny uppladdning.',
  'set.data.resetAll': 'Nollställ all data',
  'set.data.deleteBusiness': 'Ta bort företag',
  'set.data.onlyOwnerSchedule': 'Bara ägaren kan planera borttagning.',
  'set.doc.tab': 'Dokument',
  'svc.mcpMissingRedirect': 'MCP-tjänsten returnerade ingen säker omdirigering.',
  'route.dailySettlements': 'Dagsavräkningar',
  'nav.dailySettlements': 'Dagsavräkningar',
  'navhelp.dailySettlements': 'Dagsavräkningar från kassasystem, bokningssystem, uthyrningsplattformar och webbutiker. Kontrollera och godkänn före bokföring.',
  'dailySettlement.title': 'Dagsavräkningar',
  'dailySettlement.sub': 'Avräkningar från kassa, bokning, uthyrning och webbutik. Inget bokförs förrän du godkänner det.',
  'dailySettlement.refresh': 'Uppdatera',
  'dailySettlement.loadError': 'Kunde inte hämta dagsavräkningarna.',
  'dailySettlement.openSettings': 'Öppna integrationer',
  'dailySettlement.emptyTitle': 'Inga dagsavräkningar här',
  'dailySettlement.emptyText': 'När en källa är ansluten och har levererat en avräkning dyker den upp här för kontroll och godkännande.',
  'dailySettlement.filter.open': 'Att hantera',
  'dailySettlement.filter.ready': 'Klar',
  'dailySettlement.filter.review': 'Måste kontrolleras',
  'dailySettlement.filter.done': 'Färdig',
  'dailySettlement.status.ready': 'Redo för godkännande',
  'dailySettlement.status.review': 'Måste kontrolleras',
  'dailySettlement.status.approved': 'Bokförd',
  'dailySettlement.status.dismissed': 'Avslutad utan bokföring',
  'dailySettlement.attentionTitle': 'Källor som behöver uppmärksamhet',
  'dailySettlement.attentionStale': '{provider} har inte levererat någon avräkning på {days} dagar. Den senaste var {date}.',
  'dailySettlement.attentionNever': '{provider} är ansluten men har aldrig levererat någon avräkning.',
  'dailySettlement.homeWaiting': '{ready} redo för godkännande, {review} måste kontrolleras.',
  'dailySettlement.homeAction': 'Visa dagsavräkningar',
  'set.doc.title': 'Dokument',
  'set.doc.sub': 'Ladda upp och förvara egna dokument, t.ex. avtal, försäkringar eller bolagsordning.',
  'set.doc.drop': 'Dra filer hit',
  'set.doc.dropHint': 'Eller tryck för att välja fil',
  'set.doc.empty': 'Inga dokument uppladdade ännu.',
  'set.doc.added': 'Tillagt',
  'set.doc.new': 'Nytt dokument',
  'set.doc.edit': 'Redigera dokument',
  'set.doc.remove': 'Ta bort dokument',
  'set.doc.open': 'Öppna dokument',
  'set.doc.add': 'Lägg till dokument',
  'set.doc.name': 'Namn',
  'set.doc.namePh': 'T.ex. Ansvarsförsäkring 2026',
  'set.doc.nameRequired': 'Ge dokumentet ett namn först',
  'set.doc.type': 'Typ',
  'set.doc.attachTo': 'Bifogas som standard i',
  'set.doc.attachToHint': 'Dokumentet följer automatiskt med dessa dokumenttyper till kunden — kan tas bort per utskick.',
  'set.doc.uploading': 'Laddar upp...',
  'set.doc.uploaded': 'Dokument uppladdat',
  'set.doc.saved': 'Dokument uppdaterat',
  'set.doc.deleted': 'Dokument borttaget',
  'set.doc.deleteConfirm': 'Ta bort dokumentet «{name}»?',
  'set.doc.fileHint': 'PDF, Word, Excel, JPG, PNG eller WEBP. Max 10 MB.',
  'set.doc.unavailable': 'Dokumentsidan lästes inte in. Ladda om sidan — om den fortfarande är tom är det ett fel som vi måste titta på.',
  'set.doc.target.offer': 'Offerter',
  'set.doc.target.orderConfirmation': 'Orderbekräftelser',
  'set.doc.target.invoice': 'Faktura',
  'set.doc.target.creditNote': 'Kreditfaktura',
  'set.doc.target.subscription': 'Abonnemang och listor',
  'set.doc.target.subscriptionHint': 'Följer med e-post som du skickar från ett abonnemang eller en kundlista.',
  'set.doc.kind.agreement': 'Avtal',
  'set.doc.kind.insurance': 'Försäkring',
  'set.doc.kind.articles': 'Bolagsordning / stiftelseurkund',
  'set.doc.kind.authorization': 'Fullmakt',
  'set.doc.kind.certificate': 'Certifikat',
  'set.doc.kind.standard_attachment': 'Standardbilaga',
  'set.doc.kind.other': 'Annat',
  'sale.att.standard': 'Standard',
  'sale.att.removeStandard': 'Ta inte med den här gången',
  'sale.att.remove': 'Ta bort bilaga',
  'sub.standardDocs': 'Standarddokument som följer med: {names}',
  'set.data.saftXml': 'SAF-T XML (beta)',
  'set.acc.title': 'Bokföringsinställningar',
  'set.acc.sub': 'Grundinställningar för bokföringen: första räkenskapsår, momsregistrering, redovisningsmetod och liknande.',
  'set.acc.startYear': 'Startår',
  'set.acc.startYearHelp': 'Det första räkenskapsåret du bokför i Plumme. Verifikationer och rapporter före detta år hör hemma i ett tidigare system.',
  'set.acc.startInvoiceNo': 'Första fakturanummer',
  'set.acc.startInvoiceNoHelp': 'Numret som din första faktura ska få. Om du kommer från ett annat system, ange ett högre nummer än det senast använda så att du får en sammanhängande nummerserie (ett lagkrav).',
  'set.acc.vatStatus': 'Momsstatus',
  'set.acc.vatStatusHelp': 'Om företaget är registrerat i Merverdiavgiftsregisteret. Du blir momspliktig när momspliktig omsättning passerar 50 000 kr på 12 månader. Momsregistrerad betyder att du tar ut moms på försäljning och får avdrag på inköp.',
  'set.acc.vatRegistered': 'Momsregistrerad',
  'set.acc.notVatRegistered': 'Inte momsregistrerad',
  'set.acc.vatRegisteredFrom': 'Momsregistrerad från',
  'set.acc.vatRegisteredWhen': 'Var företaget momsregistrerat redan den 1 januari {year}?',
  'set.acc.vatRegisteredWhenHelp': 'Bokföringen i Plumme startar {year}. Från momsdatumet beräknas moms på försäljning och inköp — före det ingen. Om du svarar «ja» sätts datumet till 1 januari {year}.',
  'set.acc.vatRegisteredPick': 'Välj svar',
  'set.acc.vatRegisteredAtStart': 'Ja, registrerat före {year}',
  'set.acc.vatRegisteredLater': 'Nej, registrerat under {year} eller senare',
  'set.acc.vatRegisteredUnknown': 'Vet inte',
  'set.acc.vatRegisteredFromHelp': 'Datumet då företaget momsregistrerades. Före detta datum beräknas ingen moms; från och med det bokförs moms på försäljning och inköp.',
  'set.acc.standardVat': 'Förslag på nya försäljningsrader',
  'set.acc.standardVatHelp': 'Detta är bara den sats som Plumme föreslår när du skapar en ny försäljningsrad. Företaget kan använda flera momssatser, och produkten eller fakturaraden kan åsidosätta förslaget.',
  'set.acc.howFileVat': 'Hur redovisar du moms',
  'set.acc.vatPeriod': 'Momsperiod',
  'set.acc.vatPeriodHelp': 'Hur ofta du lämnar mva-melding. De flesta lämnar varannan månad (6 perioder per år). Små företag under 1 milj. kr kan ansöka om årlig redovisning. Kvartalsvis och månadsvis används i särskilda fall.',
  'set.acc.midYearTitle': 'Starta mitt i året (startsiffror)',
  'set.acc.midYearHelp': 'Använd detta om du börjar använda Plumme mitt i ett räkenskapsår. Då lägger du in startsiffror — försäljning, kostnader och moms hittills i år — från det gamla systemet, så att årsrapporter och mva-melding fortsätter med rätt siffror.',
  'set.acc.midYear': 'Starta mitt i året',
  'set.acc.enterOpening': 'Lägg in startsiffror',
  'set.acc.enterOpeningHelp': 'Öppnar formuläret där du anger övergångsdatum, moms hittills och försäljning/kostnader fördelade per konto från det tidigare systemet.',
  'set.acc.ibHelp': 'Ingående balans är de tillgångar, det eget kapital och de skulder som företaget hade vid årets början — alltså utgående balans från föregående år. Lägg in den när du startar ett nytt räkenskapsår i Plumme, så att balansräkningen stämmer från dag ett.',
  'set.acc.viewIb': 'Visa / redigera ingående balans',
  'set.acc.viewIbHelp': 'Öppnar den ingående balans du har bokfört, där du kan se raderna, redigera dem eller ta bort balansen.',
  'set.acc.addIb': 'Lägg in ingående balans',
  'set.acc.addIbHelp': 'Öppnar en guide som hjälper dig att ställa in ingående balans — du bekräftar startdatum och lägger in balansraderna (debet/kredit) från föregående år.',
  'set.acc.extraAccountsHelp': 'Lägg bara till extra konton när råbalansen eller exporten behöver dem.',
  'set.acc.searchPlaceholder': 'Sök i kontoplanen på nummer eller namn',
  'set.acc.searchNoHits': 'Inga konton matchar «{query}».',
  'set.acc.addAccount': 'Lägg till konto',
  'set.acc.addAccountHelp': 'Skapar ett eget konto i kontoplanen. Använd det bara när ett konto du behöver saknas — de flesta standardkonton finns redan.',
  'set.acc.accountNameHelp': 'Ett beskrivande namn på kontot, så som det visas i kontoplanen och rapporterna — t.ex. «Programvara/abonnemang».',
  'set.acc.accountNoHelp': 'Fyrsiffrigt kontonummer. Den första siffran bestämmer kontoklassen: 1 tillgångar, 2 eget kapital/skulder, 3 intäkter, 4–7 kostnader, 8 finans och skatt.',
  'set.acc.accountClass': 'Kontoklass',
  'set.acc.accountClassHelp': 'Huvudgruppen som kontot hamnar i, härledd automatiskt från den första siffran i kontonumret. Den styr om kontot är en tillgång, skuld, intäkt eller kostnad.',
  'set.acc.equivalent': 'Motsvarar konto',
  'set.acc.equivalentHelp': 'Kopplar det egna kontot till ett standardkonto. Det talar om för Plumme hur kontot ska hanteras i bokslut och skattemelding — så att egna konton hamnar rätt i de offentliga blanketterna.',
  'set.acc.createAccount': 'Skapa konto',
  'set.acc.ownAccounts': 'Egna konton',
  'set.acc.ownAccountsHelp': 'Konton som du själv har lagt till utöver standardkontoplanen. Bara dessa kan ändras eller tas bort.',
  'set.acc.noOwnAccounts': 'Inga egna konton ännu.',
  'set.acc.removeAccount': 'Ta bort konto',
  'set.acc.deactivated': 'inaktiverat',
  'set.acc.standardAccounts': 'Standardkonton',
  'set.acc.standardAccountsHelp': 'Den inbyggda standardkontoplanen (NS 4102). Dessa är gemensamma för alla och används automatiskt när du bokför — du behöver sällan lägga till egna.',
  'set.bank.title': 'Bankavstämning',
  'set.bank.help': 'Bankavstämning hjälper dig att kontrollera att inköp, försäljning och betalningar är bokförda en gång och stämmer med företagskontot.',
  'set.bank.activeFrom': 'Aktiv från',
  'set.bank.accounts': 'Bankkonton',
  'set.bank.primaryHelp': 'Det primära fakturakontot är standardkontot som kunderna betalar till.',
  'set.bank.disabled': 'Inaktiverat',
  'set.bank.invoiceAccount': 'Fakturakonto',
  'set.bank.activate': 'Aktivera konto',
  'set.bank.setAsInvoice': 'Ange som fakturakonto',
  'set.bank.accountNumber': 'Kontonummer',
  'set.bank.ledgerAccount': 'Konto i bokföringen',
  'set.bank.type': 'Typ',
  'set.bank.typeOperating': 'Drift',
  'set.bank.typeTax': 'Skatteavdrag',
  'set.bank.typeSavings': 'Sparande',
  'set.bank.typePrivate': 'Privat',
  'set.bank.typeOther': 'Annat',
  'set.bank.openingBalance': 'Startsaldo för bankavstämning',
  'set.bank.openingBalanceDate': 'Datum för startsaldo',
  'set.bank.reconcileIn': 'Stäm av i Bank',
  'set.bank.mustReconcile': 'Måste stämmas av',
  'set.bank.showInPayments': 'Visa i Betalt från/till',
  'set.bank.none': 'Inga bankkonton är registrerade ännu.',
  'set.bank.cards': 'Kort kopplade till kontot',
  'set.bank.cardsHelp': 'Kvitton visar ofta bara de fyra sista siffrorna. Registrera kortet, så känner Plumme igen betalningen utan att vänta på kontoutdraget. Kontotypen avgör om köpet blir företagets eller ett privat utlägg.',
  'set.bank.cardsNone': 'Kontot har inga kort',
  'set.bank.cardsNoneHelp': 'Kryssa i här, eller registrera korten, på varje betalkonto. När alla konton är klargjorda vet Plumme vilka kort företaget har: ett kvitto betalt med ett annat kort föreslås då som privat utlägg, med en anmärkning på verifikationen.',
  'set.bank.cardPromptTitle': 'Korten avgör företag eller privat',
  'set.bank.cardPromptBody': 'Plumme läser av kortnumret på kvittot. Vet vi vilka kort företaget har avgörs varje kortköp automatiskt: känner vi igen kortet blir det ett företagsköp — är det ett annat kort blir det ett privat utlägg. Dessa konton saknar svar:',
  'set.bank.cardPromptSkipHelp': 'Hoppar du över förblir kontot oklarat, och kortkvitton måste få betalningskälla manuellt. Du kan fylla i det när som helst.',
  'set.bank.cardPromptFill': 'Fyll i nu',
  'set.bank.cardPromptSkip': 'Spara utan',
  'set.bank.accountFallback': 'Bankkonto',
  'set.bank.receiptDefault': 'Standardbetalningskälla för verifikationer',
  'set.bank.receiptDefaultSub': 'Används bara när varken kort, kontoutdrag eller historik visar varifrån köpet betalades.',
  'set.bank.receiptDefaultLabel': 'Betalningskälla',
  'set.bank.receiptDefaultHint': 'Verifikationen blir klar för bokföring, men markeras orange med att källan är förvald och inte avläst från dokumentet.',
  'set.bank.receiptDefaultNone': 'Ingen – låt verifikationen stå kvar för kontroll',
  'set.bank.cardLast4': 'Sista fyra siffrorna',
  'set.bank.cardLabel': 'Namn på kortet',
  'set.bank.cardLabelPh': 'T.ex. Visa privat',
  'set.bank.cardAdd': 'Lägg till kort',
  'set.bank.cardRemove': 'Ta bort kort',
  'set.bank.cardLast4Invalid': 'Skriv de fyra sista siffrorna på kortet.',
  'set.bank.cardDuplicate': 'Kortet är redan registrerat. Två kort med samma fyra siffror kan inte skiljas åt på ett kvitto.',
  'set.access.title': 'Åtkomst',
  'set.access.sub': 'Bjud in redovisningskonsult eller samarbetspartner med egen inloggning. Åtkomsten styrs med roller.',
  'set.access.activeBusiness': 'Aktivt företag',
  'set.access.active': 'Aktiv',
  'set.access.noBusinesses': 'Inga företag är kopplade till användaren ännu.',
  'set.access.newBusiness': 'Nytt företag',
  'set.access.inviteTitle': 'Bjud in samarbetspartner',
  'set.access.inviteSub': 'Bjud in redovisningskonsult eller andra samarbetspartner, och se inbjudningar som väntar.',
  'set.access.noAdmin': 'Du har inte administratörsroll i valt företag.',
  'set.access.noAdminSub': 'Bara ägare och administratör kan bjuda in nya användare.',
  'set.access.email': 'E-post',
  'set.access.role': 'Roll',
  'set.role.accountant': 'Redovisningskonsult',
  'set.role.admin': 'Admin',
  'set.role.viewer': 'Läsbehörighet',
  'set.access.sendInvite': 'Skicka inbjudan',
  'set.access.invites': 'Inbjudningar',
  'set.access.invitesSub': 'Väntande inbjudningar för det aktiva företaget.',
  'set.access.accept': 'Acceptera',
  'set.access.pending': 'Väntar',
  'set.access.withdraw': 'Dra tillbaka',
  'set.access.noInvites': 'Inga väntande inbjudningar.',
  'set.access.deleteNote': 'Tar bara bort valt företag, inte din inloggning eller andra företag.',
  'set.access.deleteBusiness': 'Ta bort det här företaget',
  'set.access.onlyOwnerDelete': 'Bara ägaren kan ta bort företag.',
  'set.saveChanges': 'Spara ändringar',
  'set.title': 'Inställningar',
  'set.subtitle': 'Företag, användarprofil, åtkomst, bokföring, bank, investeringar och data på ett ställe.',
  'set.tabsTitle': 'Inställningsflikar',
  'set.tabsHelp': 'Varje flik är ett inställningsområde: Företag (företagsuppgifter), Användarprofil (du), Åtkomst (vem som får göra vad), Preferenser (aviseringar och visning), Bokföring (upplägg och kontoplan), Bank, Investeringar, Data (import/export), Dokument, Integrationer och Abonnemang.',
  'set.company': 'Företag',
  'set.country': 'Land',
  'set.companyName': 'Företagsnamn',
  'set.orgNumber': 'Organisationsnummer',
  'set.phone': 'Telefon',
  'set.address': 'Adress',
  'set.zip': 'Postnr',
  'set.city': 'Postort',
  'set.companyType': 'Företagsform',
  'set.logo': 'Företagslogotyp',
  'set.logoAlt': 'logotyp',
  'set.logoHelp': 'Logotyp för faktura. PNG, JPG eller WebP, max 1 MB.',
  'set.uploadLogo': 'Ladda upp logotyp',
  'set.previewInvoice': 'Förhandsgranska faktura',
  'set.deleteLogo': 'Ta bort logotyp',
  'set.inboxEmail': 'E-post för verifikationsinkorg',
  'set.inboxEmailHelp': 'Vidarebefordra leverantörsfakturor och kvitton hit för att lägga verifikationer direkt i inkorgen.',
  'set.copyEmail': 'Kopiera e-post',
  'set.generateEmail': 'Generera ny e-post',
  'set.generateEmailHelp': 'Byt bara om adressen har läckt eller tar emot skräppost. Befintliga integrationer måste uppdateras.',
  'set.profile': 'Användarprofil',
  'set.profileSub': 'Uppgifter som hör till din inloggning.',
  'set.loggedInEmail': 'Inloggad e-post',
  'set.mobile': 'Mobilnummer',
  'set.saveProfile': 'Spara användarprofil',
  'set.subscription': 'Abonnemang',
  'set.subscriptionSub': 'Fakturering styrs av backend och Stripe, inte en lokal mockplan.',
  'set.openPortal': 'Öppna kundportal',
  'set.current': 'Nuvarande',
  'adv.eyebrow': 'Ekonomisk rådgivare',
  'adv.beta': 'Beta',
  'adv.updating': 'Uppdaterar',
  'adv.lead': 'SuperPlumma analyserar din bokföring och ger dig råd som en erfaren ekonomichef — för {year}.',
  'adv.tab.overview': 'Översikt',
  'adv.tab.liquidity': 'Likviditet & risk',
  'adv.tab.sales': 'Försäljning & lönsamhet',
  'adv.tab.costs': 'Kostnader',
  'adv.sales.title': 'Försäljning och lönsamhet',
  'adv.sales.sub': 'Bokförda kundfakturor för {year}',
  'adv.sales.help': 'Alla siffror här är beräknade från bokförda kundfakturor under valt år, jämfört med samma siffror året innan. Utkast, kreditfakturor och offerter ingår inte.',
  'adv.sales.emptyTitle': 'Inga bokförda kundfakturor ännu',
  'adv.sales.emptyText': 'När du har bokfört försäljning räknar jag ut kundlönsamhet, betalningstid, rabattnivå och vilka produkter som växer.',
  'adv.sales.periodYear': 'under {year}',
  'adv.sales.periodVsPrev': 'mot {year}',
  'adv.sales.invoiceCount': '{count} fakturor',
  'adv.sales.customerCount': '{count} kunder',
  'adv.sales.recurringCount': '{count} med återkommande fakturering',
  'adv.sales.days': '{days} dagar',
  'adv.sales.noPayments': 'Inget betalt ännu',
  'adv.sales.kpi.revenue': 'Omsättning',
  'adv.sales.kpi.growth': 'Omsättningstillväxt',
  'adv.sales.kpi.growthHelp': 'Förändring i bokförd försäljning jämfört med samma period året innan. Visas som ”—” om det inte finns fjolårssiffror att jämföra med.',
  'adv.sales.kpi.avgInvoice': 'Snittbelopp per faktura',
  'adv.sales.kpi.discount': 'Snittrabatt',
  'adv.sales.kpi.discountHelp': 'Total rabatt delad med vad fakturorna hade varit värda utan rabatt. Stiger siffran utan att volymen stiger ger du bort marginal utan att få något tillbaka.',
  'adv.sales.kpi.paymentDays': 'Betalningstid',
  'adv.sales.kpi.paymentDaysHelp': 'Genomsnittligt antal dagar från fakturadatum till registrerad betalning. Bara betalda fakturor räknas — obetalda drar inte upp snittet.',
  'adv.sales.kpi.repeat': 'Återköpsgrad',
  'adv.sales.kpi.repeatHelp': 'Andel kunder med mer än en faktura under året. Hög återköpsgrad ger mer förutsägbar omsättning än lika mycket försäljning spridd på engångskunder.',
  'adv.sales.kpi.concentration': 'Kundkoncentration',
  'adv.sales.kpi.concentrationHelp': 'Hur stor andel av omsättningen som kommer från den största kunden. Över 40 % betyder att en enda kund kan stjälpa verksamheten.',
  'adv.sales.kpi.recurring': 'Återkommande intäkter',
  'adv.sales.kpi.recurringHelp': 'Andel av omsättningen som kommer från fakturor med återkommande fakturering eller abonnemang.',
  'adv.sales.customers': 'Kundlönsamhet',
  'adv.sales.customersSub': 'Omsättning, betalningstid och rabattnivå per kund',
  'adv.sales.customersHelp': 'Kunderna är sorterade efter omsättning under valt år. Trenden jämför med föregående år — en ny kund utan siffror från i fjol får en egen märkning i stället för en pil.',
  'adv.sales.col.customer': 'Kund',
  'adv.sales.col.revenue': 'Omsättning',
  'adv.sales.col.grossProfit': 'Bruttovinst',
  'adv.sales.col.paymentSpeed': 'Betalningstid',
  'adv.sales.col.discount': 'Rabatt',
  'adv.sales.col.jobs': 'Fakturor',
  'adv.sales.col.trend': 'Trend',
  'adv.sales.partialProfit': 'Inte beräknad',
  'adv.sales.trendNew': 'Ny kund i år',
  'adv.sales.showAll': 'Visa alla {count} kunder',
  'adv.sales.showFewer': 'Visa färre',
  'adv.sales.profitNote': 'Bruttovinst visas när alla fakturarader för kunden har registrerat inköpspris. Äldre fakturor och rader utan inköpspris visas som ”Inte beräknad”.',
  'adv.sales.products': 'Produkter och tjänster',
  'adv.sales.productsSub': 'Omsättning per produkt, och vad som växer eller minskar',
  'adv.sales.productsHelp': 'Produkterna hämtas från fakturaraderna. Rader utan produktnamn samlas under ”Utan produktnamn”. Tillväxt och minskning mäts mot samma produkt året innan.',
  'adv.sales.topRevenue': 'Störst omsättning',
  'adv.sales.growing': 'Störst tillväxt',
  'adv.sales.falling': 'Störst minskning',
  'adv.sales.noComparison': 'Inga siffror från i fjol att jämföra med',
  'adv.sales.verdictTag': 'Försäljning och lönsamhet just nu',
  'adv.sales.verdict.concentration': '{name} står för {pct} % av fakturaförsäljningen på {revenue}. Det är den största risken i din försäljning just nu — försvinner den kunden, försvinner större delen av omsättningen med den.',
  'adv.sales.verdict.slowPayers': 'Försäljningen i sig ser bra ut, men {count} kund(er) betalar långsamt — den långsammaste tar {days} dagar. Pengarna är intjänade; de är bara utestående längre än de behöver.',
  'adv.sales.verdict.discounts': 'Du ger i snitt {pct} % rabatt, sammanlagt {amount} i år. Det är pengar du redan har sålt för — värt att kontrollera att rabatten faktiskt ger mer volym.',
  'adv.sales.verdict.growing': 'Försäljningen växer {pct} % jämfört med i fjol och ligger nu på {revenue}. Inget i försäljningssiffrorna kräver en åtgärd just nu — det viktigaste är att hålla det igång.',
  'adv.sales.verdict.shrinking': 'Försäljningen har minskat {pct} % jämfört med i fjol och ligger på {revenue}. Det är den tydligaste signalen i dina försäljningssiffror nu.',
  'adv.sales.verdict.steady': 'Försäljningen ligger på {revenue} fördelat på {count} fakturor. Jag ser inga varningsflaggor i försäljningssiffrorna — åtgärderna nedan är möjligheter, inte problem.',
  'adv.sales.moves.title': 'Det här skulle jag göra först',
  'adv.sales.moves.sub': 'Prioriterade åtgärder, sorterade efter effekt',
  'adv.sales.moves.help': 'Varje åtgärd har en siffra bakom sig från dina egna fakturor. Effekttypen anger vilken sorts storhet siffran är — dagar, kronor eller andel — och de ska aldrig läggas ihop.',
  'adv.sales.move.chaseSlowPayers.title': 'Följ upp de långsammaste betalarna',
  'adv.sales.move.chaseSlowPayers.text': '{count} kund(er) betalar långsammare än resten. {name} tar i snitt {days} dagar.',
});
